<template>
  <div class="aoform__step" :class="{'aoform__step_hidden': hideCondition}">
    <h2 class="aoform__title">Спасибо!<br>Ваш заказ оплачен</h2>
    <p class="aoform__subtitle">Полис {{order}} отправлен на почту</p>
  </div>
</template>

<script>
export default {
  mixins: [],
  props: {
    hideCondition: {type: Boolean, required: true},
    order: {required: true}
  },
}
</script>

<style>

</style>